import React from 'react';
import Header from './Components/Header/Header';
import About from './Components/About/About';
import MiddleContainer from './Components/Middle-container/MiddleContainer';
import Contact from './Components/Contact/Contact';
import Testimonial from './Components/Testimonials/Testimonial';
import Portfolio from './Components/Portfolio/Portfolio';
import Service from './Components/ServiceSection/Service';

function Home() {
    return (
        <div className="home">
            <Header/>
            <Service/>
            <About/>
            <MiddleContainer/>
            <Portfolio/>
            <Testimonial/>
            <Contact/>
        </div>
    )
}

export default Home
